/**
 * TG Project (OCC Team) – shared constants.
 * Do not call the dashboard "OCC team page"; use "TG project page" in docs/comments.
 */

/** Fixed UID and /users doc id for the TG project owner (OCC). */
export const TG_OWNER_UID = 'VNSjlhG5nfTFnhhuKGR6AlbM7Ny2';

/**
 * Team role key for TG project participants.
 * Preserve exact typo (OCC_paricipant) for compatibility; do not rename to OCC_participant.
 */
export const OCC_PARTICIPANT_ROLE = 'OCC_paricipant';

export function isTGOwner(uid: string | null | undefined): boolean {
  return typeof uid === 'string' && uid === TG_OWNER_UID;
}
